import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as s, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconTextCursor",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  d: "M6.94 1.94A1.5 1.5 0 0 1 8 1.5h.5a.5.5 0 1 0 0-1H8a2.5 2.5 0 0 0-2 1 2.5 2.5 0 0 0-2-1h-.5a.5.5 0 0 0 0 1H4A1.5 1.5 0 0 1 5.5 3v6A1.5 1.5 0 0 1 4 10.5h-.5a.5.5 0 0 0 0 1H4a2.5 2.5 0 0 0 2-1 2.507 2.507 0 0 0 2 1h.5a.5.5 0 0 0 0-1H8A1.5 1.5 0 0 1 6.5 9V3c0-.398.158-.78.44-1.06Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function m(e, h, r, f, p, a) {
  return s(), i("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--text-cursor"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Text Cursor",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const C = /* @__PURE__ */ n(l, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=text-cursor.js.map
